module.exports = __webpack_public_path__ + "img/voteDisable.31b623fb.png";